export default __webpack_public_path__ + "static/media/centrum.56456b0a.png";